export const getAppointmentList = (store) => store.appointment.data;
export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.appointment;
  return rest;
};
export const getDoctorList = (store) => store.appointment.filters.doctor;
export const getPatientList = (store) => store.appointment.filters.patient;
